import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { get } from 'lodash'

import CollapsibleSectionHeader from '../components/CollapsibleSectionHeader'
import type { OrderCoreSchemaType } from '../orderCore.schema'
import { FormGrid, FormGroup } from '../styles/shared'
import { Input, Label } from './Details.style'
import ReviewClosing from './ReviewClosing'

const Review: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true)
  const { register, formState: { errors } } = useFormContext<OrderCoreSchemaType>()

  return (
    <>
      <CollapsibleSectionHeader
        title="Revisão da Venda"
        isOpen={isOpen}
        onToggle={() => setIsOpen((v) => !v)}
      />

      {isOpen && (
        <>
          <FormGrid columns={3}>
            <FormGroup>
              <Label htmlFor="clientOrderNumber">Nº do Pedido do Cliente</Label>
              <Input
                id="clientOrderNumber"
                type="number"
                placeholder="Digite o número"
                {...register('clientOrderNumber', {
                  /** o input devolve string; sem isto o campo viaja como texto no payload */
                  setValueAs: (v) => (v === '' || v == null ? undefined : Number(v)),
                })}
                hasError={!!get(errors, 'clientOrderNumber')}
              />
            </FormGroup>
          </FormGrid>

          <ReviewClosing />
        </>
      )}
    </>
  )
}

export default Review
